import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { trigger,style,transition,animate,keyframes,query,stagger,group, state, animateChild } from '@angular/animations';
import { IonicStorageModule } from '@ionic/storage';
import { Facebook, FacebookLoginResponse } from '@ionic-native/facebook';
import { UniqueDeviceID } from '@ionic-native/unique-device-id';

import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Geolocation } from '@ionic-native/geolocation';
// http
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';

import { PublicTabsPage } from '../pages/public-tabs/public-tabs';
import { ComingSoonPage } from '../pages/coming-soon/coming-soon';

import { LivePage } from '../pages/live/live';
import { UpcomingPage } from '../pages/upcoming/upcoming';
import { HomePage } from '../pages/home/home';
import { TabsPage } from '../pages/tabs/tabs';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Network } from '@ionic-native/network';
import { NativeStorage } from '@ionic-native/native-storage';

import { ApiProvider } from '../providers/api/api';  
import { ConfigProvider } from '../providers/config/config';
import { SiriProvider } from '../providers/siri/siri';
import { UserProvider } from '../providers/user/user';
import { SmartAudioProvider } from '../providers/smart-audio/smart-audio';
import { NativeAudio } from '@ionic-native/native-audio';
import { Settings } from '../providers/settings/settings';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// The translate loader needs to know where to load i18n files
// in Ionic's static asset pipeline.   
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


@NgModule({
  declarations: [
    MyApp,
    ComingSoonPage,
    PublicTabsPage,
    LivePage,
    UpcomingPage,
    HomePage,
    TabsPage
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
    TranslateModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    ComingSoonPage,
    PublicTabsPage,
    LivePage,
    UpcomingPage,
    HomePage,
    TabsPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    InAppBrowser,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ApiProvider,
    ConfigProvider,
    SiriProvider,
    UserProvider,
    SmartAudioProvider,
    NativeAudio,
    UniqueDeviceID,
    Facebook,
    NativeStorage,
    Network,
    Geolocation, 
    Storage
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts